import * as React from 'react';
import Text from 'components/Text';
import AsyncSelectItem from 'components/AsyncSelectItem';
// @ts-ignore
import { Organization } from './types';

type Props = {
  organization: Organization;
};

export default function OrganizationPickerItem(props: Props) {
  const { organization } = props;
  const address = [organization.city, organization.state].filter(Boolean).join(', ');

  return (
    <AsyncSelectItem title="">
      <div style={{ padding: '15px' }}>
        <Text align="left" element="div" color="graphite">
          <Text element="div" size="medium" weight="semibold">
            {organization.name}
          </Text>
          <Text element="div" size="xsmall">
            {address}
          </Text>
          <Text element="div" size="xsmall">
            {organization.members_sample_string}
          </Text>
        </Text>
      </div>
    </AsyncSelectItem>
  );
}
